import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';

import { fetchCustomPlanPricingList } from 'actions/customPlans';
import { getCustomPlanPricingList, getPageCount } from 'reducers';

const withCustomPlanPricing = (DecoratedComponent) => {
  class WithCustomPlanPricing extends Component {
    state = {
      loading: false,
    };

    componentDidMount() {
      this.fetchCustomPlanPricingList();
    }

    componentDidUpdate(oldProps) {
      const {
        user_profile,
        att_plan,
        simo_plan,
        quick_plan,
        is_effective,
        is_visible,
        page,
      } = this.props;

      if (
        oldProps.page !== page ||
        oldProps.user_profile !== user_profile ||
        oldProps.att_plan !== att_plan ||
        oldProps.simo_plan !== simo_plan ||
        oldProps.quick_plan !== quick_plan ||
        oldProps.is_effective !== is_effective ||
        oldProps.is_visible !== is_visible
      ) {
        this.fetchCustomPlanPricingList();
      }
    }

    fetchCustomPlanPricingList = () => {
      const {
        fetchCustomPlanPricingList,
        page,
        user_profile,
        att_plan,
        simo_plan,
        quick_plan,
        is_effective,
        is_visible,
      } = this.props;
      const filters = {
        user_profile: user_profile || undefined,
        att_plan: att_plan || undefined,
        is_effective: is_effective || undefined,
        is_visible: is_visible || undefined,
        simo_plan: simo_plan || undefined,
        quick_plan: quick_plan || undefined,
      };

      this.setState({ loading: true });
      fetchCustomPlanPricingList(page, filters)
        .then(() => this.setState({ loading: false }))
        .catch((e) => console.log(e));
    };

    render() {
      const { children, ...props } = this.props;
      const { loading } = this.state;
      return React.createElement(
        DecoratedComponent,
        {
          loading,
          fetchCustomPlanPricingListWithFilters:
            this.fetchCustomPlanPricingList,
          ...props,
        },
        children,
      );
    }
  }

  const mapStateToProps = (state, { location: { search } }) => {
    const {
      page = 1,
      user_profile,
      att_plan,
      simo_plan,
      quick_plan,
      is_effective,
      is_visible,
    } = qs.parse(search, { ignoreQueryPrefix: true });
    const customPlanPricingList = getCustomPlanPricingList(state, page);
    const defaultIsEffective = 'true';

    return {
      customPlanPricingList,
      pageCount: getPageCount(
        state,
        'customPlans',
        'fetchCustomPlanPricingList',
        page,
      ),
      page,
      user_profile,
      att_plan,
      simo_plan,
      quick_plan,
      is_effective: is_effective || defaultIsEffective,
      is_visible,
    };
  };

  const mapDispatchToProps = {
    fetchCustomPlanPricingList,
  };

  return connect(mapStateToProps, mapDispatchToProps)(WithCustomPlanPricing);
};

export default withCustomPlanPricing;
